import { observable, action } from 'mobx';
import firebaseService from '../FirebaseService';
import Utils from '../Utils';

class PolicyStore {
    @observable Policies = [];
    @observable LoadingPolicies = false;
    @observable IsAddingPolicy = false;
    @observable ShowAddPolicy = false;
    @observable LoadingDocForUpdate = false;
    @observable IsDeletingPolicy = false;
    @observable DocIdToDelete = "";
    @observable AddPolicyRequest = {
        DocId: "",
        DocName: "",
        Description: "",
        Content: "",
        Category: "",
        Subcategory: "",
        Version: "",
        ModifiedDate: ""
    }
    @action UpdateAddPolicyRequestProperty(key, value) {
        this.AddPolicyRequest[key] = value;
    }
    @action GetPolicies() {
        this.LoadingPolicies = true;
        firebaseService.Policies()
            .then((snapshot) => {
                this.Policies = [];
                snapshot.forEach((childSnapshot) => {
                    this.Policies.push(childSnapshot.val());
                })
            })
            .catch((err) => { console.log(err); Utils.Toast.Error("Unable to retrieve policies"); })
            .finally(() => { this.LoadingPolicies = false; });
    }
    @action ToggleAddPolicyModal(id) {
        if (id !== undefined && id !== null && id !== "") {
            this.LoadingDocForUpdate = true;
            firebaseService.GetPolicy(id)
                .then((snapshot) => {
                    var policy = snapshot.val();
                    Utils.Basic.CopyTo(policy, this.AddPolicyRequest);
                })
                .catch((err) => { console.log(err); Utils.Toast.Error("Unable to retrieve policy with Id : " + id); })
                .finally(() => { this.LoadingDocForUpdate = false; })
        }
        else{
            this.AddPolicyRequest.DocId = "";
        }
        this.ShowAddPolicy = this.ShowAddPolicy ? false : true;
    }
    @action AddPolicy() {
        if (this.AddPolicyRequest.DocId === "") {
            this.IsAddingPolicy = true;
            firebaseService.AddPolicy(this.AddPolicyRequest)
                .then(() => {
                    this.ToggleAddPolicyModal();
                    this.GetPolicies();
                })
                .catch((err) => { console.log(err); Utils.Toast.Error("Unable to Add policy"); })
                .finally(() => { this.IsAddingPolicy = false; })
        } else {
            this.IsAddingPolicy = true;
            firebaseService.UpdatePolicy(this.AddPolicyRequest)
                .then(() => {
                    this.ToggleAddPolicyModal();
                    this.GetPolicies();
                })
                .catch((err) => { console.log(err); Utils.Toast.Error("Unable to update policy"); })
                .finally(() => { this.IsAddingPolicy = false; })
        }
    }
    @action DeletePolicy(){
        this.IsDeletingPolicy = true;
        firebaseService.GetPolicy(this.DocIdToDelete)
        .then((snapshot) => {
          snapshot.ref.remove();
          this.GetPolicies();
        })
        .catch((err) => { console.log(err); Utils.Toast.Error("Unable to delete policy"); })
        .finally(() => { this.IsDeletingPolicy = false; this.DocIdToDelete = ""; })
    }
}
export default new PolicyStore();


// WEBPACK FOOTER //
// ./src/stores/PolicyStore.js